// TODO:区分コード管理.xlsx参考
/**
 * C0001	車種区分
 */
export const e車種区分 = {
  フルトレーラ: "1",
  セミトレーラ: "2",
  バンセミトレーラ: "3",
  バンフルトレーラ: "4",
  タンクセミトレーラ: "5",
  コンテナセミトレーラ: "6",
  ダンプセミトレーラ: "7",
  粉粒体運搬セミトレーラ: "8",
  ポールトレーラ: "9",
  ダンプ: "10",
  バン: "11",
  トラクタ: "12",
  タンク車: "13",
  キャブオーバ: "14",
  コンテナ専用車: "15",
  脱着装置付コンテナ専用車: "16",
  キャブオーバ_トラクタ: "17",
  バン_トラクタ: "18",
  粉粒体運搬車: "19",
  冷蔵冷凍車: "20",
} as const

export type T車種区分名称 = keyof typeof e車種区分
export type T車種区分 = typeof e車種区分[T車種区分名称]

// C0002	陸運支局分類区分
// C0003	ETC設置区分
export const eETC設置区分 = {
  未設置: "0",
  ETC1_0: "1",
  ETC2_0: "2",
} as const
// C0004	車載装置区分
// C0005	点検整備区分
export const e点検整備区分 = {
  法令点検_車検: "1",
  法令点検_３ヶ月: "2",
  整備: "3",
  事故修繕: "4",
  自主点検: "5",
} as const

export type T点検整備区分名称 = keyof typeof e点検整備区分
export type T点検整備区分 = typeof e点検整備区分[T点検整備区分名称]
// C0006	タイヤ種類区分
// C0007	タイヤメーカー区分

// C0008 給油取込区分
export const e給油取込区分 = {
  自社給油: "1",
  宇佐美給油: "2",
  一光給油: "3",
  中日本給油: "4",
  飯田運輸給油: "5",
  予備カード給油: "6",
  現金給油: "7",
}

export type T給油取込区分名称 = keyof typeof e給油取込区分
export type T給油取込区分 = typeof e給油取込区分[T給油取込区分名称]
